import { useCallback } from "react"
import validate from "validate.js"
import { INIT_VALIDATION_ERRORS } from "../../commonActionTypes"
import { createValidationStructure } from "../../Helper"
import { useCurrentShipmentType, useValidation } from "../../hooks"
import { cdsFieldPatterns } from "../util/cdsFieldPattern"
import { validateContainers, invoiceDataConversion } from "../util/cdsValidateFunctions"
import { validateInvoices } from "../../NL_App/util/itemsTabValidation"

export const useValidationCDS = (tabName) => {

    const { validateError, updateError } = useValidation(tabName)
    const { isImportShipment } = useCurrentShipmentType()

    const initHeaderTabValidationCDS = useCallback(() => {
        return (dispatch, getState) => {
            const { Shipment } = getState();
            let headerTabError = validate(Shipment, cdsFieldPatterns(isImportShipment)()?.header) || {}
            headerTabError = createValidationStructure(headerTabError)
            dispatch({ type: INIT_VALIDATION_ERRORS, payload: { header: headerTabError } })
        }
    }, [])

    const initContainersTabValidationCDS = useCallback(() => {
        return (dispatch, getState) => {
            const { containerReducer } = getState();
            let containersError = validateContainers(containerReducer?.containerList, cdsFieldPatterns(isImportShipment)()?.containers)
            dispatch({ type: INIT_VALIDATION_ERRORS, payload: { containers: containersError } })
        }
    }, [])

    const initItemsTabValidationCDS = useCallback(() => {
        return (dispatch, getState) => {
            const { InvoicesReducer, Shipment } = getState();
            let itemsError = validateInvoices(invoiceDataConversion(InvoicesReducer?.invoice), cdsFieldPatterns(isImportShipment)({ declarationCat: Shipment.declarationCat })?.items)
            dispatch({ type: INIT_VALIDATION_ERRORS, payload: { items: itemsError } })
        }
    }, [])

    return {
        validateError,
        updateError,
        initHeaderTabValidationCDS,
        initContainersTabValidationCDS,
        initItemsTabValidationCDS
    }
}